<template>
    <div v-if="showBanner" class="cookie-backdrop">
        <div class="cookie-modal">
            <button class="close-button" @click="closeBanner">×</button>
            <h4 class="text-center">Manage Consent</h4>
            <p>
                To provide the best experiences, we use technologies like cookies to store and/or access device information. Consenting to these technologies will allow us to process data such as browsing behavior or unique IDs on this site. Not consenting or withdrawing consent, may adversely affect certain features and functions.
            </p>

            <div v-if="!showPreferences">
                <div class="actions">
                    <button class="btn-accept" @click="acceptAll">Accept</button>
                    <button class="btn-deny" @click="rejectAll">Deny</button>
                    <button class="btn-save" @click="showPreferences = true">View preferences</button>
                </div>
            </div>

            <div v-if="showPreferences" class="cookie-preferences-container">
                <div class="cookie-preferences scrollable-section show">
                    <details class="category functional" @toggle="toggleDetails('functional', $event)">
                        <summary>
                            <div class="category-header">
                                <span class="category-title">Functional</span>
                                <div class="category-controls">
                                    <span class="always-active"><label for="functional">Always active</label></span>
                                    <font-awesome-icon :icon="['fas', 'chevron-down']" :class="{ rotated: detailsOpen.functional }" />
                                </div>
                            </div>
                        </summary>
                        <div class="description">
                            The technical storage or access is strictly necessary for the legitimate purpose of enabling the use of a specific service explicitly requested by the subscriber or user, or for the sole purpose of carrying out the transmission of a communication over an electronic communications network.
                        </div>
                    </details>

                    <details class="category statistics"  @toggle="toggleDetails('statistics', $event)">
                        <summary>
                            <div class="category-header">
                                <span class="category-title">Statistics</span>
                                <div class="category-controls">
                                    <span class="checkbox">
                                        <input type="checkbox" id="statistics" v-model="preferences.statistics" />
                                        <label for="statistics" class="slider"></label>
                                    </span>
                                    <font-awesome-icon :icon="['fas', 'chevron-down']" :class="{ rotated: detailsOpen.statistics }" />
                                </div>
                            </div>
                        </summary>
                        <div class="description">
                            The technical storage or access that is used exclusively for anonymous statistical purposes. Without a subpoena, voluntary compliance on the part of your Internet Service Provider, or additional records from a third party, information stored or retrieved for this purpose alone cannot usually be used to identify you.
                        </div>
                    </details>
                </div>

                <div class="actions">
                    <button class="btn-accept" @click="acceptAll">Accept</button>
                    <button class="btn-deny" @click="rejectAll">Deny</button>
                    <button class="btn-save" @click="savePreferences">Save preferences</button>
                </div>
            </div>
            

            <div class="link-container text-center mt-3">
                <router-link to="/cookie-policy" class="cookie-policy-link">Cookie Policy</router-link>
                <router-link to="/privacy-policy" class="privacy-policy-link">Privacy Policy</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    const GA_IDS = ['G-GWZTL8CHV2', 'G-P9HP0TSSVG'];
    function loadGtag(callback) {
        if (window.gtag) {
            callback();
            return;
        }

        /* global dataLayer */
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_IDS[0]}`;
        script.onload = () => {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () { dataLayer.push(arguments); };
            window.gtag('js', new Date());
            callback();
        };
        document.head.appendChild(script);
    }

export default {
    data() {
        return {
            showBanner: true,
            showPreferences: false,
            detailsOpen: {
                functional: false,
                statistics: false
            },
            preferences: {
                functional: true,
                statistics: false
            }
        };
    },
    mounted() {
        this.checkCookiePreferences();
    },
    watch: {
        $route() {
            this.checkCookiePreferences();
        }
    },
    methods: {
        checkCookiePreferences() {
            const prefs = localStorage.getItem("cookiePreferences");
            console.log("Consentimientos LocalStorage: ", prefs);
            if (prefs) {
                this.preferences = JSON.parse(prefs);
                this.showBanner = !this.preferences.statistics;
                this.applyPreferences();
            } else {
                this.showBanner = true;
            }
        },
        closeBanner() {
            this.showBanner = false;
        },
        acceptAll() {
            this.preferences = { functional: true, statistics: true };
            this.savePreferences();
        },
        rejectAll() {
            this.preferences = { functional: true, statistics: false };
            this.savePreferences();
        },
        acceptCookies() {
            this.savePreferences();
        },
        savePreferences() {
            localStorage.setItem("cookiePreferences", JSON.stringify(this.preferences));
            this.showPreferences = false;
            this.showBanner = false;
            this.applyPreferences();
        },
        applyPreferences() {
            if (this.preferences.statistics) {
                loadGtag(() => {
                    window.gtag('consent', 'update', {
                        'analytics_storage': 'granted',
                        'ad_storage': 'denied',
                        'ad_user_data': 'denied',
                        'ad_personalization': 'denied'
                    });

                    GA_IDS.forEach(gaId => {
                        window.gtag('config', gaId, {
                            anonymize_ip: true
                        });
                    });
                });
            }
        },
        toggleDetails(section) {
            this.detailsOpen[section] = !this.detailsOpen[section];
        }
    }
};
</script>

<style scoped>
.cookie-backdrop {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9998;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cookie-modal {
    position: relative;
    background: #fff;
    padding: 2rem;
    max-width: 600px;
    width: 90%;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    z-index: 9999;
}

.cookie-modal .close-button {
    position: absolute;
    top: 0.5rem;
    right: 1rem;
    background: transparent;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
}

.cookie-modal .close-button {
    color: var(--blackColor);
    background: transparent;
}

.cookie-modal .actions {
    margin-top: 1rem;
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    width: 100%;
}

.cookie-modal .actions button {
    flex-shrink: 1;
    flex-basis: 0;
}

.cookie-modal button {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
}

.cookie-modal p {
    font-size: 14px;
}

.cookie-modal .link-container {
    display: inline-flex;
    gap: 1rem;
    justify-content: center;
    width: 100%;
}

.cookie-modal .privacy-policy-link, .cookie-policy-link {
    color: #1E73BE;
    text-decoration: underline;
    cursor: pointer;
    font-weight: normal;
    padding: 0;
    background: none;
    font-size: 14px;
}

.cookie-modal .btn-accept {
    color: var(--whiteColor);
    background-color: #1E73BE;
    flex-grow: 1.5;
    border: 1px solid var(--mainColor, #007BFF);
    transition: background-color 0.2s ease, border-color 0.2s ease;
}

.cookie-modal .btn-deny {
    background-color: #e9ecef;
    flex-grow: 1;
    border: 1px solid #d6d8db;
    transition: background-color 0.2s ease, border-color 0.2s ease;
}

.cookie-modal .btn-save {
    background-color: #e9ecef;
    flex-grow: 1.5;
    border: 1px solid #d6d8db;
    transition: background-color 0.2s ease, border-color 0.2s ease;
}

.cookie-modal .btn-deny:hover,
.cookie-modal .btn-save:hover {
    background-color: #dee2e6;
    border-color: #c4c7ca;
    cursor: pointer;
}

.cookie-modal.btn-accept:hover {
    background-color: #0069d9;
    border-color: #0062cc;
    cursor: pointer;
}

.cookie-modal .cookie-preferences {
    max-height: 50vh;
}

.cookie-modal .category {
    background-color: #e9ecef;
    border-top: 1px solid #ddd;
    margin-bottom: 10px;
}

.cookie-modal .category-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    grid-gap: 10px;
    padding: 10px;
}

.cookie-modal .category-controls {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.cookie-modal .category-title {
    color: var(--mainColor);
    font-weight: bold;
}

.cookie-modal .always-active,
.cookie-modal .checkbox {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding-right: 1rem;
}

.cookie-modal .always-active {
    color: green;
}

.cookie-modal .description {
    padding: 10px;
    font-size: 0.9rem;
}

.cookie-modal summary::marker {
    content: "";
}

.cookie-modal .category-header .rotated {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
}

.cookie-modal .checkbox {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
}

.cookie-modal .checkbox input {
    opacity: 0;
    width: 0;
    height: 0;
}

.cookie-modal .checkbox .slider {
    position: absolute;
    cursor: pointer;
    top: 0; left: 0;
    right: 0; bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 20px;
}

.cookie-modal .checkbox .slider::before {
    content: "";
    position: absolute;
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
}

.cookie-modal .checkbox input:checked + .slider {
    background-color: #2196F3;
}

.cookie-modal .checkbox input:checked + .slider::before {
    transform: translateX(20px);
}

cookie-preferences-container {
    max-height: 80vh;
}

.scrollable-section {
    overflow-y: auto;
    padding-right: 5px;
    flex-grow: 1;
}
</style>
